import {createSvgIcon} from "@mui/material";

export const CheckmarkIcon = createSvgIcon(
    <svg width="46" height="46" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.5 6 9 18l-4.5-4.5"></path>
    </svg>,
    'CheckmarkIcon'
)